
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getProjectSharePublicAddressDtoFormGroup() {
return new FormGroup({
    street: new FormControl<string | undefined>(undefined),
    zip: new FormControl<string | undefined>(undefined),
    city: new FormControl<string | undefined>(undefined),
})
;
}
      